const tables = [
  {
    name: "Number",
  },
  {
    name: "Name",
  },
  {
    name: "Job",
  },
  {
    name: "Expense",
  },
  {
    name: "Task Status",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
